import Vue from 'vue';
import Headroom from 'headroom.js';
import { gsap } from 'gsap';

Vue.component('model-in-page-navigation', {
    mounted() {
        // grab an element
        var myElement = document.querySelector('.model__navigation');
        // construct an instance of Headroom, passing the element
        var headroom = new Headroom(myElement);
        // initialise
        headroom.init();
    },

    data() {
        return {
            showMenu: false,
        };
    },

    watch: {
        showMenu: function(visible) {
            EventBus.$emit('navigation-state-changed', visible);
            if (!visible) {
                gsap.set(document.body, {
                    overflow: null,
                });
                return;
            }

            gsap.set(document.body, {
                overflow: 'hidden',
            });
        },
    },

    methods: {},
});
